<template>
  <div id="specialCategories" class="container">
    <div class="swiper-container">
      <div
        v-if="special_categories && special_categories.length"
        class="swiper-wrapper"
      >
        <div
          class="category-list swiper-slide"
          v-for="(category, index) in special_categories"
          :key="index"
        >
          <router-link
            class="category-link"
            :to="{
              name: 'product.category',
              params: { category: category.id },
            }"
          >
            <div class="category-image">
              <img
                v-if="category.image"
                class="w-100 h-100"
                :src="category.image.url"
                :alt="category.title"
              />
            </div>
            <div class="category-title">
              <h4>
                {{ category.title }}
              </h4>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper/swiper-bundle.min";
export default {
  computed: {
    special_categories() {
      if (this.$store.getters["front/getHomeData"]) {
        return this.$store.getters["front/getHomeData"].special_categories;
      } else {
        return null;
      }
    },
  },
  mounted() {
    this.initialSwiper();
  },
  watch: {
    special_categories(newValue) {
      if (newValue) {
        this.initialSwiper(true);
      }
    },
  },
  methods: {
    initialSwiper(kill = false) {
      this.initSwiper("specialCategories", kill, () => {
        if (this.slider) {
          this.slider.destroy();
        }
        this.slider = new Swiper("#specialCategories .swiper-container", {
          loop: false,
          speed: 500,
          breakpoints: {
            250: {
              slidesPerView: 2,
              spaceBetween: 15,
            },
            400: {
              slidesPerView: 3,
              spaceBetween: 15,
            },
            500: {
              slidesPerView: 4,
              spaceBetween: 15,
            },
            768: {
              slidesPerView: 6,
              spaceBetween: 15,
            },
            992: {
              slidesPerView: 7,
              spaceBetween: 15,
            },
            1200: {
              slidesPerView: 10,
              spaceBetween: 15,
            },
          },
        });
      });
    },
  },
};
</script>

<style scoped>
#specialCategories {
  margin-block: 0.5rem 2rem;
}
#specialCategories .category-list .category-link {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex-direction: column;
}
#specialCategories .category-list .category-image {
  width: 100%;
  height: 100px;
  overflow: hidden;
  border-radius: 5px;
}
#specialCategories .category-list .category-title h4 {
  text-align: center;
  color: #000000;
  font-size: 0.9vw;
  font-weight: 500;
  margin: 0;
}
</style>
